import { api } from './http';
import type { CallStats, TradeCall, TradeCallInput } from './types';

export const calls = {
  list: (signal?: AbortSignal) => api.get<{ calls: TradeCall[]; stats: CallStats }>('/calls', signal),
  get: (id: number) => api.get<{ call: TradeCall }>(`/calls/${id}`),
  create: (f: TradeCallInput) => api.post<{ call: TradeCall }>('/calls', f),
  update: (id: number, f: TradeCallInput) => api.put<{ call: TradeCall }>(`/calls/${id}`, f),
  remove: (id: number) => api.del<{ ok: true }>(`/calls/${id}`),
};
